

//Function to calculate the invoice totals
export function calculateInvoiceTotals(products, combos, invoiceTip) {


    // Función para redondear hacia arriba si el tercer decimal es mayor a 0
    function roundUpToTwoDecimals(value) {
        //console.log("Nuevo redondeo de tax");
        //console.log(value);
        // Verificamos si hay más de dos decimales
        const decimals = value.toString().split('.')[1];

        if (decimals && decimals.length > 2) {
            // Si el tercer decimal es mayor que 0, redondeamos hacia arriba
            if (parseInt(decimals[2]) > 0) {
                return Math.ceil(value * 100) / 100;
            }
        }

        //console.log(parseFloat(value.toFixed(2)));

        // Si ya tiene dos decimales o menos, devolvemos el valor tal cual
        return parseFloat(value.toFixed(2));
    }

    //For every new calculate we set the totals
    let taxesArray = [];
    let invoiceTotalDiscount = 0
    let invoiceSubtotal = 0
    let invoiceTotalItbms = 0
    let invoiceTotal = 0;
    let deliveryFeeTax = 0;
    let invoiceDeliveryFee = 0;
    //if we dont we products we put the totals in 0 for default
    if ((products.length + combos.length) === 0) {
        //We calculate the totals of the invoice
        /* setInvoiceTotalDiscount(0)
         setInvoiceSubtotal(0);
         setInvoiceTotalItbms(0)
         setInvoiceTotal(0);
         setInvoiceDeliveryFee(0);
         setInvoiceTaxDeliveryFee(0);
         setTaxesArrayAll(taxesArray)*/

        let jsonTotals = {
            invoiceTotalDiscount: 0,
            invoiceSubtotal: 0,
            invoiceTotalItbms: 0,
            invoiceTotal: 0,
            InvoiceDeliveryFee: 0,
            InvoiceTaxDeliveryFee: 0,
            taxesArray: taxesArray,
            totaltopay: 0
        }

        return jsonTotals;
    } else {

        //For every combos we calculate
        combos.forEach((combo) => {

            byProductandCombo(combo)
        })

        products.forEach((group) => {
            byProductandCombo(group)
        })

        //Esta funcion calcula los valores por producto o combo por posicion
        function byProductandCombo(item) {

            //Variables
            let total_product_price = 0;
            let total_product_itbms = 0;
            let product_total_discount = 0;
            //We set the total discount of the product
            product_total_discount = (item.unit_discount * item.amount);
            //We set the total of the product
            total_product_price = (item.amount * (item.price - item.unit_discount));

            //Calculate tax by group--------------------------------
            let taxesGroup = item.taxes;
            taxesGroup.forEach(tax => {
                //calculate tax  value and add it to array
                let valueTax = roundUpToTwoDecimals((item.amount * ((item.price - item.unit_discount) * tax.taxtValue)));
                //console.log(valueTax);
                tax.total = valueTax;
                //Identifier tax of the group position
                var index = taxesArray.findIndex(function (info, i) {
                    return info.tax_id === tax.tax_id
                });

                if (index < 0) {
                    let taxInfoNow = {
                        "dTasaITBMSValue": tax.dTasaITBMSValue,
                        "percentage": tax.percentage,
                        "tax": tax.tax,
                        "tax_id": tax.tax_id,
                        "taxtValue": tax.taxtValue,
                        "total": valueTax
                    }
                    taxesArray.push(taxInfoNow);
                } else {
                    taxesArray[index].total = (taxesArray[index].total + valueTax)
                }
                total_product_itbms = (total_product_itbms + valueTax)

            });

            //We calculate the totals of the invoice
            invoiceTotalDiscount = invoiceTotalDiscount + product_total_discount;
            invoiceSubtotal = invoiceSubtotal + total_product_price;
            invoiceTotalItbms = invoiceTotalItbms + total_product_itbms;
            invoiceTotal = invoiceTotal + total_product_price + total_product_itbms;
        }


        //console.log("incoiveDeliveryFee", invoiceDeliveryFee);
        //console.log("deliveryFeeTax", deliveryFeeTax);
        //console.log("invoiceTotalDiscount:" + invoiceTotalDiscount);
        //console.log("invoiceSubtotal:" + invoiceSubtotal);
        //console.log("invoiceTotalItbms:" + invoiceTotalItbms);
        //console.log("invoiceTotal:" + invoiceTotal);

        let jsonTotals = {
            invoiceTotalDiscount: roundUpToTwoDecimals(invoiceTotalDiscount),
            invoiceSubtotal: roundUpToTwoDecimals(invoiceSubtotal),
            invoiceTotalItbms: roundUpToTwoDecimals(invoiceTotalItbms),
            invoiceTotal: roundUpToTwoDecimals(invoiceTotal),
            taxesArray: taxesArray,
            totaltopay: roundUpToTwoDecimals(invoiceTotal + invoiceTip)
        }

        return jsonTotals;
        let newArray = []
    }

    //setHandlerEvent(1)
}